// Stored websites are typed as entered, so a bare host would otherwise open a portal page.
export function externalHref(value) {
  const text = String(value ?? '').trim();
  if (!text) return null;

  const hasHttpScheme = /^https?:\/\//i.test(text);
  const isBareHost = /^(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+(?:[/?#]\S*)?$/i.test(text);
  if (!hasHttpScheme && !isBareHost) return null;

  const candidate = hasHttpScheme ? text : `https://${text}`;
  try {
    const parsed = new URL(candidate);
    if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname) return null;
  } catch {
    return null;
  }

  return candidate;
}
